import React from 'react';
import { Flow } from 'flow-react';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import * as ConfigTypes from 'config/ConfigTypes';
import UIButton from "components/UI/Button/Button";
import { reduceDataByFi, getItemStyle, getRentalFields, randomNr }
    from "helpers/CartHelper";
import { getDialogConfig, getMetaConfig, getCartRequestData, addToCartRequestData }
    from "helpers/ConfigHelper";
import { parseStringField } from "helpers/FieldHelper";
import { isHome } from 'helpers/AppHelper';
import { changeDateFormat } from 'helpers/DateHelper';
import './RentEdit.scss'


const RentEdit = observer(
    class RentEdit extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                data: [],
            }
        }

        fm = (id) => this.props.intl.formatMessage({ id });

        initData = () => {
            let dialogMode = ConfigTypes.RENT_EDIT;
            let fields = getDialogConfig({
                dialogMode, configObjects: this.props.configObjects, configName: "userconfig"
            });
            let data = getCartRequestData({ fields: fields, dialogMode });
            let configFields = getMetaConfig({
                viewMode: ConfigTypes.RENT_EDIT, props: this.props,
                configName: ConfigTypes.ITEM
            });
            let newData = addToCartRequestData({ fields: configFields, dialogMode, data });
            let wFields = getMetaConfig({
                viewMode: ConfigTypes.RENT_EDIT, props: this.props,
                configName: ConfigTypes.WORK
            });
            newData = addToCartRequestData({ fields: wFields, dialogMode, data: newData });;
            let instFields = getDialogConfig({
                dialogMode, configObjects: this.props.configObjects, configName: "instconfig"
            });
            newData = addToCartRequestData({ fields: instFields, dialogMode, data: newData });
            console.log("LOGS: LAMTEST CartRequest initData", newData);
            this.setState({ data: newData });
        }


        setTopDates = () => {
            let offer_from = changeDateFormat({ date: new Date("2024-09-24") });
            let offer_to = changeDateFormat({ date: new Date("2024-10-24") });
            this.setState({ offer_from, offer_to, offer_clerk: ConfigTypes.DEFAULT_CLERK });
        }

        getTopHeader = () => {
            return (
                <div className="rentedit-topbox">
                    {ConfigTypes.CARTREQUEST_CLERK.map(item => {
                        return (
                            <>
                                {item.isBracket && '('}
                                <div>{item.intl && this.fm(item.intl)}&nbsp;</div>
                                {item.intl_bold && (
                                    <div className="rentedit-bold">
                                        {this.fm(item.intl_bold)}&nbsp;
                                    </div>
                                )}
                                <div className={`${item.isBold && 'rentedit-bold'}`}>
                                    {this.state[item.name]}&nbsp;
                                </div>
                                {item.isBracket && ')'}
                            </>
                        )
                    })}
                </div>
            )
        }

        acceptOffer = () => {
            const { itemsRentalList } = this.props.cartObjects;
            const { rentalFields, listData } = getRentalFields({ props: this.props });
            let newRentalList = [];
            if (listData && listData.length) {
                newRentalList = listData.map((item, i) => {
                    let obj = {};
                    rentalFields.forEach(el => {
                        let fi = `${ConfigTypes.ONLY_CART}${el.field}`;
                        obj[fi] = null
                        if (item[fi]) obj[fi] = item[fi];
                        else if (el.createUnique) obj[fi] = randomNr();
                        else if (el.createStatus) obj[fi] = ConfigTypes.RENTAL_STATUS[i].value;
                    });
                    return obj;
                });
            }
            console.log("LAMTEST newRentalList", newRentalList);
            this.props.updateCartObjects({
                itemsCartList: [],
                itemsRentalList: [...itemsRentalList, ...newRentalList]
            });
        }

        handleBtnClick = (el) => {
            if (el.name && el.name === ConfigTypes.ACCEPT_OFFER) {
                this.acceptOffer();
            }
            if (!isHome()) this.props.router.navigate("/");
            this.props.updateMediaObjects({ viewMode: ConfigTypes.LIST });
        }

        showButton = ({ el, idx }) => {
            return (
                <div className="rentedit-row" key={`cartrequet_btn_${idx}${el.name}`}>
                    <UIButton textOnly onClick={() => this.handleBtnClick(el)}
                        className="rentedit-button">
                        {this.fm(el.intl)}
                    </UIButton>
                </div>)
        }

        showLink = ({ el, idx }) => {
            let key = `rentedit-${el.name}${idx}`;
            return (
                <div className="rentedit-linkdata" key={key}>
                    <a className="rentedit-link" href={el.txtLinkUrl} target="_">
                        {this.fm(el.intl)}
                    </a>
                </div>
            )
        }

        showBreakLine = (idx, noLine = false) => {
            return (
                <div className="rentedit-breakline-box"
                    key={`rentedit_breakline_${idx}`}>
                    <div className={!noLine && 'rentedit-breakline'} />
                </div>)
        }

        showText = ({ el, idx }) => {
            let text = this.props.user.metadata.fields[`${el.field}`]
                ? this.props.user.metadata.fields[`${el.field}`] : "";
            if (typeof text == 'object' && text.intl) {
                text = this.props.intl.formatMessage({ id: text.intl });
            }
            if (el.type && el.type === ConfigTypes.TEXT_FROM_CHILDREN
                && el.children && el.children.length > 0
            ) {
                let all = el.children.map(child => this.props.user.metadata.fields[child.field]);
                if (all && all.length) text = all.join(" ");
            }
            return (
                <div className="rentedit-txt-row"
                    key={`rentedit_text_${idx}`}>
                    {el.withLabel && (<label className="rentedit-label">
                        {this.fm(el.intl)}:
                    </label>)}
                    <div className="rentedit-text">
                        <span>{text}</span>
                    </div>
                </div>
            )
        }

        showInfo = ({ el, idx }) => {
            return (
                <div key={`rentedit_info_${idx}`}>
                    <span className={el.htmlClasses && el.htmlClasses}>
                        {this.fm(el.intl)}
                    </span>
                </div>
            )
        }

        showOtherData = ({ el, idx, data, withSpace = true }) => {
            if (el.data && el.data.length > 0 && data) {
                return el.data.map((entry, index) => {
                    if (entry.type === ConfigTypes.BREAKLINE) {
                        return this.showBreakLine({ el: entry, idx: index });
                    }
                    if (entry.type === ConfigTypes.INFO) {
                        return <div>{this.props.intl.formatMessage({ id: entry.intl })}</div>
                    }

                    if (entry.type === ConfigTypes.TEXT_FROM_CHILDREN
                        && entry.children && entry.children.length > 0
                    ) {
                        let text = "";
                        let all = entry.children.map(child => data[child.field]);
                        if (all && all.length) text = all.join(" ");
                        return <div>{text}</div>
                    }

                    let isLabel = true;
                    if (entry[`${ConfigTypes.RENT_EDIT}noLabelList`] || !entry.intl) isLabel = false;
                    return (
                        <div className="rentedit-contentbox"
                            key={`rentedit_ul_li_children_child${idx}`}>
                            {(isLabel) && (
                                <div className={`${withSpace && 'rentedit-contentlabel'} ${entry.htmlClasses}`}>
                                    {this.fm(entry.intl)} : </div>
                            )}
                            <div className={`${entry.htmlClasses}`}>
                                {data[entry.field] && data[entry.field]}</div>
                        </div>)
                })
            }
        }

        showDates = ({ entry, item, idx }) => {
            if (item.metadata.fields[entry.field]
                && item.metadata.fields[entry.field].length > 0)
                return (
                    <div key={`rentedit_ul_li_children_child_${idx}}`}>
                        {item.metadata.fields[entry.field].map((date, i) => {
                            return (
                                <div key={`rentedit_ul_li_children_child_date${i}}`}>
                                    {this.fm(entry.intl)} {i + 1} : {date}
                                </div>
                            )
                        })}
                    </div>
                )
        }

        showTxtFrChildren = ({ item, el, entry, idx }) => {
            if (entry.children && entry.children.length > 0) {
                let all = entry.children.map(child => {
                    //return parseStringField(item.metadata.fields[`${ConfigTypes.ONLY_CART}${child.field}`]);
                    return parseStringField(item[`${ConfigTypes.ONLY_CART}${child.field}`]);
                });
                if (all && all.length) all = all.join(" ");
                return (
                    <div className={`rentedit-contentbox ${el.htmlClasses && el.htmlClasses}`}
                        key={`rentedit_ul_li_children_child${idx}`}>{all}</div>
                )
            }
        }

        showItemRow = ({ item, el, entry, idx }) => {
            let isLabel = true;
            if (entry[`${ConfigTypes.RENT_EDIT}noLabelList`] || !entry.intl) isLabel = false;
            let text = item.metadata.fields[entry.field] || "";
            if (el.isWork) {
                //text = item.metadata.fields[`${ConfigTypes.ONLY_CART}${entry.field}`] || "";
                text = item[`${ConfigTypes.ONLY_CART}${entry.field}`] || "";
            }
            text = parseStringField(text);
            return (
                <div className={`rentedit-contentbox ${el.htmlClasses && el.htmlClasses}`}
                    key={`rentedit_ul_li_children_child${idx}`}>
                    {(isLabel) && (
                        <div>{this.fm(entry.intl)} : </div>
                    )}
                    <div>{text}</div>
                </div>)
        }

        getItemClasses = ({ el, x }) => {
            const { itemsCartList } = this.props.cartObjects;
            if (x === (itemsCartList.length - 1)) return null;
            if (el && el.name && el.name.startsWith(ConfigTypes.ITEM)) {
                return "rentedit-cartitem";
            }
            return "rentedit-workbox";
        }

        getItemHeading = ({ el, x }) => {
            if (x == 0) return null;
            if (el && el.name && el.name == ConfigTypes.WORK_INFO) {
                return this.fm("cartrequest.work");
            }

            if (el && el.name && el.name == ConfigTypes.ITEM_INFO) {
                return this.fm("cartrequest.item");
            }
        }


        showCartItem = ({ item, el, idx }) => {
            if (el.data && el.data.length > 0) {
                return el.data.map((entry, index) => {
                    if (entry.type === ConfigTypes.TEXT_FROM_CHILDREN) {
                        return this.showTxtFrChildren({ item, el, entry, idx: index });
                    }
                    if (entry.type === ConfigTypes.INFO) return this.showInfo({ el: entry, idx: index });
                    if (entry.type === ConfigTypes.BREAKLINE) {
                        return this.showBreakLine({ el: entry, idx: index });
                    }
                    if (entry.type === ConfigTypes.DATES) {
                        return this.showDates({ entry, item, idx });
                    }
                    return this.showItemRow({ item, el, entry, idx: index });
                })
            }
            return null;
        }

        showCartList = ({ el, idx }) => {
            const { itemsCartList } = this.props.cartObjects;
            let cartData = [...itemsCartList];
            if (el.isWork) {
                cartData = reduceDataByFi({ el, list: itemsCartList, fiName: ConfigTypes.IS_REDUCED });
            }
            if (cartData && cartData.length > 0) {
                return cartData.map((item, x) => {
                    let styleObj = getItemStyle({ item, el, x });
                    let htmlClasses = this.getItemClasses({ el, x });
                    return (
                        <div className={htmlClasses} style={styleObj}>
                            {this.getItemHeading({ el, x })}
                            {this.showCartItem({ item, el, idx })}
                        </div>
                    )
                })
            }
        }

        showElement = ({ el, idx }) => {
            switch (el.type) {
                case ConfigTypes.BREAKLINE:
                    return this.showBreakLine(idx, el.noLine);
                case ConfigTypes.BUTTON:
                    return this.showButton({ el, idx });
                case ConfigTypes.LINK:
                    return this.showLink({ el, idx });
                case ConfigTypes.TEXT:
                case ConfigTypes.TEXT_FROM_CHILDREN:
                    return this.showText({ el, idx });
                case ConfigTypes.INFO:
                    return this.showInfo({ el, idx });
                case ConfigTypes.ITEMS_CARTLIST:
                    return this.showCartList({ el, idx });
                case ConfigTypes.INVOICE:
                    return this.showOtherData({ el, idx, data: this.props.cartObjects });
                case ConfigTypes.OWNER_INST:
                    return this.showOtherData({ el, idx, data: this.props.owner, withSpace: false });
                default:
                    return (
                        <div key={`rentedit_ul_li_children_child${idx}`}>{el.name}</div>
                    )
            }
        }

        showSingleItem = ({ item, k }) => {
            return (
                <li className="rentedit-content-li" key={`rentedit_ul_li_${k}`}>
                    {item.children.map((el, index) => {
                        let htmlClasses = `rentedit-content-li-item ${el.htmlClasses && el.htmlClasses}`;
                        if (el.children && el.children.length > 0) {
                            return (
                                <div className={htmlClasses} key={`rentedit_ul_li_children${index}`}>
                                    {el.intl && this.fm(el.intl)}
                                    {el.children.map((entry, idx) => this.showElement({ el: entry, idx, isChild: true }))}
                                </div>)
                        }
                        return (
                            <div className="rentedit-content-li-item"
                                key={`rentedit_ul_li_children${index}`}>
                                {el.intl && this.fm(el.intl)}
                                {this.showElement({ el, idx: index })}
                            </div>
                        )
                    })}
                </li>
            )
        }


        componentDidMount() {
            this.initData();
            this.setTopDates();
        }

        render() {
            return (
                <div className="rentedit">
                    {this.getTopHeader()}
                    <ul className="rentedit-content-list">
                        {this.state.data.map((item, k) => {
                            if (item.children && item.children.length > 0) {
                                return (this.showSingleItem({ item, k }))
                            }
                            return (<div key={`rentedit_ul_li_${k}`}>{item.name}</div>)
                        })}
                    </ul>
                </div>)
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    cartObjects: state.cart.cartObjects,
    configObjects: state.config.configObjects,
    user: state.auth.authObjects.user,
    owner: state.auth.authObjects[ConfigTypes.INST_DATA]["kinemathek"]
});

const mapDispatchToProps = (dispatch) => ({
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(RentEdit))));


